import { render, staticRenderFns } from "./ShipmentsInquiryGrid.vue?vue&type=template&id=23b580ce&"
import script from "./ShipmentsInquiryGrid.vue?vue&type=script&lang=js&"
export * from "./ShipmentsInquiryGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports